import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d2db53f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dv-head" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 0,
  class: "w-100 text-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "scanner-main-container" }

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';   
  import { IonButton } from '@ionic/vue';
  import { ref } from 'vue';  
  import { type Result, StreamQrcodeBarcodeReader } from 'vue3-barcode-qrcode-reader';
  import { inject, onMounted } from "vue";
  import {BarCodeResult} from '@/services/BarCodeService';  

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BarCodeReaderWebComponent',
  setup(__props) {

  //https://github.com/tomimandalap/vue3-barcode-qrcode-reader
  const dialogRef:any = inject('dialogRef');
  const refCamera = ref<InstanceType<typeof StreamQrcodeBarcodeReader> | null>(null);  
  const isLoading = ref<boolean>(false);
  const helptext = ref<string>('');

  const onResult = (data: Result | undefined): void => 
  {  
    if(data)
    {      
      let bcf:any = data.getBarcodeFormat();
      const barResult:BarCodeResult = { text:data.getText(), format: bcf ,result:data }
      dialogRef.value.close(barResult);
    }
  }
  const onLoading = (loading: boolean) =>
  {
    isLoading.value = loading;
  }
  const handleOnCanPlay = () =>
  {
    refCamera.value?.onCanPlay();
  }  
  const handleOnCanStop = () =>
  {
    refCamera.value?.onCanStop();
  }        
  onMounted(() => 
  {
    const params = dialogRef.value.data;
    if(params)
    {
      if(params.data && params.data.helpText)
      {
        helptext.value = params.data.helpText
      }      
    }    
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(IonButton), {
              fill: "clear",
              color: 'control',
              onClick: handleOnCanPlay
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'camera'] }),
                _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t('globals.Iniciar')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(IonButton), {
              fill: "clear",
              color: 'danger',
              onClick: handleOnCanStop
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(FontAwesomeIcon), { icon: ['fas', 'times'] }),
                _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t('globals.Detener')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (helptext.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(helptext.value), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('globals.BarcodeHelpText')), 1))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(StreamQrcodeBarcodeReader), {
          ref_key: "refCamera",
          ref: refCamera,
          capture: "shoot",
          "show-on-stream": "",
          onOnloading: onLoading,
          onResult: onResult
        }, null, 512)
      ])
    ])
  ]))
}
}

})